import { useEffect, useState } from "react";
import { useEvent } from "./useEvent";

export function useControllable<T>(controlledValue: T | undefined, onChange?: (value: T) => void, defaultValue?: T) {
  let [internalValue, setInternalValue] = useState(defaultValue);
  let isControlled = controlledValue !== undefined;
  useEffect(() => {
    if (defaultValue) setInternalValue(defaultValue);
  }, [defaultValue]);
  return [
    (isControlled ? controlledValue : internalValue)!,
    useEvent((value) => {
      if (isControlled) {
        return onChange?.(value);
      } else {
        setInternalValue(value);
        return onChange?.(value);
      }
    }),
  ] as const;
}
